import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
  dataCreate: any;
  isFetchingCreate: boolean;
  errorCreate: boolean; 
}

const initialState: State = {
  isFetching: false,
  error: false,
  data: {},
  dataCreate: {},
  isFetchingCreate: false,
  errorCreate: false
}

export const password = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        isFetchingReset: true
      }
    case actionTypes.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        isFetchingReset: false,
        errorReset: true
      }
    case actionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isFetchingReset: false,
        errorReset: false,
        dataReset: action.data
      }
    default:
      return state;
  }
}
